import React from 'react';
import PropTypes from 'prop-types';
import validator from 'validator';
import RecipientManagerConstants from './RecipientManagerConstants';
import PublicLinkBody from './PublicLinkBody';
import AddRecipientsBody from './AddRecipientsBody';

export default class RecipientManagerBody extends React.Component {
  constructor(props) {
    super(props);

    this.allValidEmails = this.allValidEmails.bind(this);
    this.openPreviewAddRecipients = this.openPreviewAddRecipients.bind(this);
    this.openPreviewPublicLink = this.openPreviewPublicLink.bind(this);
  }

  allValidEmails() {
    for (let i = 0; i < this.props.emails.length; i += 1) {
      if (!validator.isEmail((this.props.emails[i]).trim())) {
        return false;
      }
    }
    return true;
  }

  openPreviewAddRecipients() {
    window._track('Preview | Add Recipients', 'Template Builder');
    this.props.openPreview();
  }

  openPreviewPublicLink() {
    window._track('Preview | Share Link', 'Template Builder');
    this.props.openPreview();
  }

  render() {
    const emptyTemplateTooltipText = 'Add at least one answer box on your document to share.';
    if (this.props.activeTab === RecipientManagerConstants.RECIPIENT_MANAGER_ADD_RECIPIENTS_TAB_SHOW) {
      return (
        <AddRecipientsBody
          addNewEmailField={this.props.addNewEmailField}
          clickCancel={this.props.clickCancel}
          clickSend={this.props.clickSend}
          currentMessage={this.props.message}
          emails={this.props.emails}
          emptyTemplateTooltipText={emptyTemplateTooltipText}
          handleBlur={this.props.handleBlur}
          handleEmailChange={this.props.handleEmailChange}
          handleMessageChange={this.props.handleMessageChange}
          hasEmailInputBlurred={this.props.hasEmailInputBlurred}
          isEditingPopup={this.props.isEditingPopup}
          isPreviewButtonEnabled={this.props.isPreviewButtonEnabled}
          isTemplateEmpty={this.props.isTemplateEmpty}
          openPreview={this.openPreviewAddRecipients}
          publishedAt={this.props.publishedAt}
          removeEmailField={this.props.removeEmailField}
          sendDisabled={!this.allValidEmails()}
          setPopupCreationError={this.props.setPopupCreationError}
        />
      );
    }
    return (
      <PublicLinkBody
        clickPublish={this.props.clickPublish}
        documentType={this.props.documentType}
        emptyTemplateTooltipText={emptyTemplateTooltipText}
        isEditingPopup={this.props.isEditingPopup}
        isPreviewButtonEnabled={this.props.isPreviewButtonEnabled}
        isPublic={this.props.isPublic}
        isTemplateEmpty={this.props.isTemplateEmpty}
        openPreview={this.openPreviewPublicLink}
        publishedAt={this.props.publishedAt}
        setPopupCreationError={this.props.setPopupCreationError}
      />
    );
  }
}

RecipientManagerBody.defaultProps = {
  emails: [],
  isEditingPopup: false,
  isPreviewButtonEnabled: true,
  isTemplateEmpty: false,
  message: '',
  openPreview: null,
  publishedAt: null,
};

RecipientManagerBody.propTypes = {
  activeTab: PropTypes.string.isRequired,
  addNewEmailField: PropTypes.func.isRequired,
  clickCancel: PropTypes.func.isRequired,
  clickPublish: PropTypes.func.isRequired,
  clickSend: PropTypes.func.isRequired,
  documentType: PropTypes.string.isRequired,
  emails: PropTypes.arrayOf(PropTypes.string),
  handleBlur: PropTypes.func.isRequired,
  handleEmailChange: PropTypes.func.isRequired,
  handleMessageChange: PropTypes.func.isRequired,
  hasEmailInputBlurred: PropTypes.arrayOf(PropTypes.bool).isRequired,
  isEditingPopup: PropTypes.bool,
  isPreviewButtonEnabled: PropTypes.bool,
  isPublic: PropTypes.bool.isRequired,
  isTemplateEmpty: PropTypes.bool,
  message: PropTypes.string,
  openPreview: PropTypes.func,
  publishedAt: PropTypes.string,
  removeEmailField: PropTypes.func.isRequired,
  setPopupCreationError: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src-react/SelfServePostBuilderSidePanel/RecipientManager/RecipientManagerBody.jsx